import { render, staticRenderFns } from "./development.vue?vue&type=template&id=4fcd13b6&scoped=true"
import script from "./development.vue?vue&type=script&lang=js"
export * from "./development.vue?vue&type=script&lang=js"
import style0 from "./development.vue?vue&type=style&index=0&id=4fcd13b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd13b6",
  null
  
)

export default component.exports